import { useState } from "react";
import { CodeFormProps } from "../CodeFormInfos";

export function CodeFormNormal(p: CodeFormProps) {
  const [currentCode, setCurrentCode] = useState<string>("");

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        p.checkCode(currentCode);
      }}
      style={{ marginBottom: "15vh" }}
    >
      {p.errorMessage ? (
        <h2 className="is-family-monospace login-tooltip is-nok">
          {p.errorMessage.split("\n").map((elmt, idx) => (
            <span key={idx}>
              {elmt}
              <br />
            </span>
          ))}
        </h2>
      ) : (
        <></>
      )}
      <div className="field code-app-field">
        <div className="control">
          <input
            className="input is-family-monospace"
            name="code"
            value={currentCode}
            onChange={(e) => setCurrentCode(e.target.value)}
            {...p.formInfos}
          />
        </div>
        <div className="control">
          <button className="button is-fullwidth is-family-monospace is-active">
            VALIDER
          </button>
        </div>
      </div>
    </form>
  );
}
